module.exports = __webpack_public_path__ + "static/media/GarantyIcon.f4ff6913.svg";